var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSpeedRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 11.35a.75.75 0 010 1.3l-9 5.196a.75.75 0 01-1.125-.65V6.804a.75.75 0 011.125-.65l9 5.197z",
    fill: "currentColor"
  })));
}
SvgPokerSpeedRegular.displayName = 'PokerSpeedRegular';
export default SvgPokerSpeedRegular;